
import Paperclip2 from "../../../assets/duotone/Paperclip2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Paperclip2Icon({ className, dataTestid = "Paperclip2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Paperclip2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
